import { render, staticRenderFns } from "./Banking.vue?vue&type=template&id=566783a0&scoped=true&"
import script from "./Banking.vue?vue&type=script&lang=js&"
export * from "./Banking.vue?vue&type=script&lang=js&"
import style0 from "./Banking.vue?vue&type=style&index=0&id=566783a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566783a0",
  null
  
)

export default component.exports